export default {
    getCategory: state => (categoryId) => state.categories.find((category) => category.id == categoryId),
    getCategories: state => state.categories,
    getStore: state => (storeId) => state.stores.find((store) => store.id == storeId),
    getStores: state => state.stores,
    getProduct: state => (productId) => state.products.find((product) => product.id == productId),
    getProducts: state => state.products
  }
